import { render, staticRenderFns } from "./VDivider.vue?vue&type=template&id=93869eee&scoped=true&"
import script from "./VDivider.vue?vue&type=script&lang=js&"
export * from "./VDivider.vue?vue&type=script&lang=js&"
import style0 from "./VDivider.vue?vue&type=style&index=0&id=93869eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93869eee",
  null
  
)

export default component.exports